import React from 'react';
import classnames from 'classnames';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import { Form } from 'formik';

const useStyles = createUseStyles<string, {}, any>((theme: Theme) => ({
  form: {
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
  },
  scrollableContent: {
    padding: theme.marginBase * 4,
    flex: 1,
    overflow: 'auto',
    [theme.media.mobile]: {
      padding: theme.marginBase * 3,
    },
  },
  buttonContainer: {
    width: '100%',
    padding: `${theme.marginBase * 2}px ${theme.marginBase * 3}px`,
    backgroundColor: theme.colors.white,
  },
  buttonContainerShadow: {
    boxShadow: theme.boxShadow.base,
  },
}));

interface Props {
  children: React.ReactNode;
  submitSectionContent?: React.ReactNode;
  submitShadow?: boolean;
  noForm?: boolean;
}

export const PaneLayout = ({
  children,
  submitSectionContent,
  submitShadow,
  noForm,
}: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });

  const Container = noForm ? 'div' : Form;
  return (
    <Container className={classes.form}>
      <div className={classes.scrollableContent}>{children}</div>
      {submitSectionContent && (
        <div
          className={classnames(classes.buttonContainer, {
            [classes.buttonContainerShadow]: !!submitShadow,
          })}
        >
          {submitSectionContent}
        </div>
      )}
    </Container>
  );
};
